export default {
  data () {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      allertMessage: null
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert (sec, message) {
      this.allertMessage = message
      this.dismissCountDown = sec
    }
  }
}
